import { finish, error } from '../../../modules/bets/actions/comment-bet';
import api from '../../../api';

export function request(dispatch, { id, accountId, comment }) {
    api.put('/bets/' + id + '/comment', { accountId, comment }).then(
        (data) => dispatch(finish(id, data)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
